<template>
  <div>
    <nav class="navbar-desktop">
      <div class="navbar-desktop__logo">
        MaidGrow
      </div>
      <div class="navbar-desktop__menu">
        <ul>
          <router-link
            v-for="{ label, to } in links"
            :key="label"
            :to="to"
            class="navbar-desktop__menu-item"
            active-class="navbar-desktop__menu-item--active"
            tag="li"
          >
            {{ label }}
          </router-link>
        </ul>
      </div>
      <div
        class="navbar-desktop__logout"
        role="button"
        @click="handleClick"
      >
        {{ $t('navLinks.logout') }}
        <img src="@/assets/icons/logout.svg" alt="logout" />
      </div>
    </nav>
    <nav class="navbar-mobile">
      <div class="navbar-mobile__header">
        <div class="navbar-mobile__logo">
          MaidGrow
        </div>
        <div
          class="navbar-mobile__menu-icon"
          role="button"
          @click="toggleMenuVisibility()"
        >
          <img v-if="!menuVisible" src="@/assets/icons/hamburger.svg" alt="menu icon" />
          <img v-else src="@/assets/icons/close.svg" alt="close icon" />
        </div>
      </div>
      <div v-if="menuVisible" class="navbar-mobile__menu">
        <ul>
          <router-link
            v-for="{ label, to } in links"
            :key="label"
            :to="to"
            class="navbar-mobile__menu-item"
            exact-active-class="navbar-mobile__menu-item--active"
            tag="li"
          >
            {{ label }}
          </router-link>
        </ul>
        <div
          class="navbar-mobile__logout"
          role="button"
          @click="handleClick"
        >
          {{ $t('navLinks.logout') }}
          <img src="@/assets/icons/logout.svg" alt="logout" />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('user');

export default {
  name: 'Navbar',
  data() {
    return {
      links: [
        { label: this.$t('navLinks.dashboard'), to: '/dashboard' },
        { label: this.$t('navLinks.createEstimate'), to: '/new-estimate' },
        { label: this.$t('navLinks.pastEstimates'), to: '/past-estimates' },
        { label: this.$t('navLinks.settings'), to: '/settings' },
      ],
      menuVisible: false,
    };
  },
  computed: { ...mapState(['loggedIn']) },
  methods: {
    ...mapActions(['logOut']),
    async handleClick() {
      await this.logOut();
      this.$router.push('/login');
    },
    toggleMenuVisibility() {
      this.menuVisible = !this.menuVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
  .navbar-desktop {
    align-items: center;
    background-color: $white;
    border-radius: 24px;
    box-shadow: 0 2px 83px 0 rgba(34, 48, 87, .07);
    display: none;
    height: 84px;
    justify-content: space-between;
    margin-bottom: 26px;
    padding: 0 35px;
    width: 100%;

    @include md-up {
      display: flex;
    }

    &__logo {
      font-family: Ubuntu;
      font-size: 17px;
      font-weight: bold;
      letter-spacing: .34px;
    }

    &__menu {
      height: 100%;

      ul {
        align-items: center;
        display: flex;
        height: 100%;
        list-style: none;
        margin: 0;
        padding: 0;
      }
    }

    &__menu-item {
      align-items: center;
      border-bottom: 3px solid $white;
      cursor: pointer;
      display: flex;
      font-size: 15px;
      font-weight: 700;
      height: 100%;
      letter-spacing: .2px;
      margin-right: 63px;
      transition: .2s;

      &:last-of-type {
        margin-right: 0;
      }

      &:hover,
      &--active {
        border-color: $accent;
        color: $blueDarker;
      }
    }

    &__logout {
      color: $secondary;
      cursor: pointer;
      font-size: 13px;
      font-weight: 500;

      img {
        margin-left: 16px;
      }
    }
  }

  .navbar-mobile {
    background-color: $white;
    box-shadow: 0 2px 83px 0 rgba(34, 48, 87, .07);
    left: 0;
    min-height: 90px;
    padding: 0 24px;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;

    @include md-up {
      display: none;
    }

    &__header {
      align-items: center;
      display: flex;
      height: 90px;
      justify-content: space-between;
      width: 100%;
    }

    &__logo {
      font-family: Ubuntu;
      font-size: 17px;
      font-weight: bold;
      letter-spacing: .34px;
    }

    &__menu-icon {
      cursor: pointer;
    }

    &__menu {
      align-items: center;
      display: flex;
      flex-direction: column;
      padding: 24px 0 48px;

      ul {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        list-style: none;
        margin: 0;
        padding: 0;
      }
    }

    &__menu-item {
      font-size: 15px;
      font-weight: 500;
      letter-spacing: .2px;
      margin-bottom: 40px;

      &--active {
        color: $blueDarker;
        font-weight: bold;
      }
    }

    &__logout {
      color: $secondary;
      font-size: 13px;
      font-weight: 500;
      margin-top: 30px;

      img {
        margin-left: 16px;
      }
    }
  }
</style>
